import styled from 'styled-components'

const ButtonDescription = styled.p`
  margin: 4px 0 0 0;
  font-size: ${props => props.styles.fontSize || '12px'};
  font-weight: ${props => props.styles.fontWeight || 'normal'};
  font-family: ${props => props.styles.fontFamily};
  padding-left: 12px;
  padding-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default ButtonDescription
